import { motion, AnimatePresence } from "framer-motion";
import { Hero } from "../HomeComponents/Hero";
import { DivisionsSection } from "../HomeComponents/Division";
import PillarsSection from "../HomeComponents/Pillar";
import PartnersCarousel from "../HomeComponents/Corousel";
import CertificationsCarousel from "../HomeComponents/CertificateCarousel";
import StatsMapSection from "../HomeComponents/Statmap";
import BigDivision from "../HomeComponents/BigDivision";
import { DownloadSection } from "../HomeComponents/Download";
import SplashScreen from "../HomeComponents/SplashScreen";
import FooterSection from "../HomeComponents/Footer";
import { MobileDrawer, MobileHeader, TopNav } from "../HomeComponents/Header";
const HomePage = ({
  isDesktop,
  isMobileMenuOpen,
  setIsMobileMenuOpen,
  isLoading,
  handleSplashComplete,
  THEME,
}) => {
  return (
    <div
      style={{
        fontFamily: "Inter, system-ui, sans-serif",
        minHeight: "100vh",
        margin: 0,
        padding: 0,
        boxSizing: "border-box",
        position: "relative",
        overflowX: "hidden",
      }}
    >
      {/* Global Resets */}
      <style>{`
        body { margin: 0; padding: 0; }
        * { box-sizing: border-box; }
      `}</style>

      {/* Background Texture */}
      <div
        style={{
          position: "fixed",
          inset: 0,
          backgroundImage: `url("SquareParticles@2x.png")`,
          backgroundRepeat: "repeat",
          backgroundSize: "contain",
          opacity: 0.15,
          pointerEvents: "none",
          zIndex: 0,
        }}
      />

      <div style={{ position: "relative", zIndex: 1 }}>
        <AnimatePresence>
          {isLoading && <SplashScreen onComplete={handleSplashComplete} />}
        </AnimatePresence>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: isLoading ? 0 : 1 }}
          transition={{ duration: 1 }}
        >
          {/* Navigation */}
          {!isDesktop && (
            <MobileHeader
              isOpen={isMobileMenuOpen}
              setIsOpen={setIsMobileMenuOpen}
            />
          )}

          <MobileDrawer
            isOpen={isMobileMenuOpen}
            setIsOpen={setIsMobileMenuOpen}
          />

          {isDesktop && <TopNav />}

          {/* Main Content */}
          <main>
            <Hero isDesktop={isDesktop} THEME={THEME} />
            <BigDivision isDesktop={isDesktop} THEME={THEME} />
            <PillarsSection isDesktop={isDesktop} THEME={THEME} />
            <PartnersCarousel isDesktop={isDesktop} THEME={THEME} />

            <div style={{ transform: "scale(0.9)" }}>
              <CertificationsCarousel isDesktop={isDesktop} THEME={THEME} />
            </div>

            <DivisionsSection isDesktop={isDesktop} THEME={THEME} />
            <StatsMapSection isDesktop={isDesktop} THEME={THEME} />
            <DownloadSection isDesktop={isDesktop} THEME={THEME} />
            <FooterSection isDesktop={isDesktop} THEME={THEME} />
          </main>
        </motion.div>
      </div>
    </div>
  );
};

export default HomePage;
